import React from 'react';

type OwnProps = React.PropsWithChildren<{
  indexToDisplay: number;
  offsetToLoad?: number;
  totalItems: number;
  visibleSlideIndex: number;
}>;

export default function LazyDisplayItem({
  children,
  offsetToLoad = 2,
  totalItems,
  visibleSlideIndex,
  indexToDisplay
}: OwnProps) {
  const isInWindow =
    Math.abs(visibleSlideIndex - indexToDisplay) < offsetToLoad;
  const isInBackwardWrappedWindow =
    visibleSlideIndex < offsetToLoad &&
    totalItems - indexToDisplay < offsetToLoad;
  const isInForwardWrappedWindow =
    indexToDisplay < offsetToLoad &&
    totalItems - visibleSlideIndex < offsetToLoad;
  const isIndexInWindow =
    isInWindow || isInBackwardWrappedWindow || isInForwardWrappedWindow;

  return isIndexInWindow ? children : null;
}
